import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { Component, OnInit } from '@angular/core'
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators
} from '@angular/forms'
import { Router } from '@angular/router'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import { Observable, of } from 'rxjs'
import {
  catchError,
  filter,
  startWith,
  switchMap,
  take,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'

import { OperationType } from '../../operation/operation'
import { operationActions } from '../../operation/operation.actions'
import { AccessRights } from '../../role/user-role/user-role'
import { Survey } from '../../survey/survey'
import { surveyActions } from '../../survey/survey.actions'
import { surveySelectors } from '../../survey/survey.selectors'
import { Sale } from '../sale'
import { saleSelectors } from '../sale.selectors'

@Component({
  selector: 'sale-actions-main-tab',
  templateUrl: './sale-actions-tab.component.html',
  styleUrls: ['./sale-actions-tab.component.scss']
})
@UntilDestroy()
export class SaleActionsMainTabComponent implements OnInit {
  public saleId$: Observable<number>
  public sale$: Observable<Sale>
  public surveys$: Observable<Survey[]>
  public isLoading$: Observable<boolean>
  public form: UntypedFormGroup
  public accessRights = AccessRights
  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private actions$: Actions,
    private router: Router,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      surveyId: [null, [Validators.required]]
    })

    this.saleId$ = this.store
      .select(saleSelectors.selectIdRouteParam)
      .pipe(filter((saleId) => Boolean(saleId)))

    this.sale$ = this.saleId$.pipe(
      switchMap((saleId) => this.store.select(saleSelectors.selectById, saleId))
    )

    this.isLoading$ = this.store
      .select(surveySelectors.selectIsLoading)
      .pipe(startWith(false))

    this.store.dispatch(
      surveyActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: { isActive: true }
        })
      })
    )

    this.surveys$ = this.store.select(surveySelectors.selectAll)
  }

  public onSearchSurveys(term: string) {
    this.store.dispatch(
      surveyActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            $and: [
              {
                name: { [CondOperator.CONTAINS_LOW]: term },
                isActive: true
              }
            ]
          }
        })
      })
    )
  }

  public onFormSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })
      return
    }
    this.store
      .select(authSelectors.selectMember)
      .pipe(take(1))
      .subscribe((user) => {
        this.sale$.pipe(untilDestroyed(this)).subscribe((sale) => {
          this.store.dispatch(
            operationActions.createOne({
              entity: {
                siteId: user.siteId,
                memberId: sale?.customerPersonId,
                type: OperationType.SURVEY,
                isPending: true,
                priority: 0,
                updatedAt: moment(),
                createdAt: moment(),
                surveyId: this.form.value.surveyId
              }
            })
          )
        })
      })

    this.actions$
      .pipe(
        ofType(operationActions.upsertMany),
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
      .subscribe((action) => {
        if (action) {
          this.notificationService.emit('alerts.success', 'success')
        }
      })

    this.form.reset()
  }
}
